(()=>{const initMenu=(root=document)=>{root.querySelectorAll('.uc-menu-button').forEach(btn=>{if(btn.dataset.ready)return;btn.dataset.ready='true';btn.addEventListener('click',()=>{const menu=document.getElementById(btn.getAttribute('aria-controls'));const open=btn.getAttribute('aria-expanded')==='true';btn.setAttribute('aria-expanded',String(!open));if(menu)menu.hidden=open})})};const initPersonalizer=(root=document)=>{root.querySelectorAll('[data-personalizer]').forEach(box=>{if(box.dataset.ready)return;box.dataset.ready='true';const pairs=[...box.querySelectorAll('[data-pair]')];const count=box.querySelector('[data-progress-count]');const bar=box.querySelector('[data-progress-bar]');const update=()=>{let done=0;pairs.forEach(pair=>{const inputs=[...pair.querySelectorAll('input[type=file]')];if(inputs.length&&inputs.every(i=>i.files&&i.files.length))done++});if(count)count.textContent=done+'/9';if(bar)bar.style.width=(done/9*100)+'%'};box.querySelectorAll('input[type=file]').forEach(input=>{input.addEventListener('change',()=>{const label=input.closest('.uc-upload');const text=label&&label.querySelector('[data-file-label]');if(input.files&&input.files[0]){if(label)label.classList.add('has-file');if(text)text.textContent='✓ '+input.files[0].name}else{if(label)label.classList.remove('has-file');if(text)text.textContent=input.dataset.kind==='photo'?'Wybierz zdjęcie':'Wybierz piosenkę'}update()})});update()})};const init=()=>{initMenu();initPersonalizer()};document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();document.addEventListener('shopify:section:load',e=>{initMenu(e.target);initPersonalizer(e.target)})})();

;(()=>{
  const selector=[
    '.uc-section__intro',
    '.uc-moment-card',
    '.uc-story__heading',
    '.uc-story__media',
    '.uc-featured-product__copy',
    '.uc-featured-product__media',
    '.uc-steps__grid article',
    '.uc-stats__grid>div',
    '.uc-quotes blockquote',
    '.uc-faq__layout>div',
    '.uc-final>div',
    '.uc-product-main__layout>*',
    '.uc-product-details article'
  ].join(',');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const observer=('IntersectionObserver' in window)&&!reduced.matches?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  },{threshold:.13,rootMargin:'0px 0px -7% 0px'}):null;
  const initMotion=(root=document)=>{
    document.documentElement.classList.add('uc-motion-ready');
    const nodes=[...root.querySelectorAll(selector)];
    if(root.nodeType===1&&root.matches(selector))nodes.unshift(root);
    nodes.forEach((node,index)=>{
      if(node.classList.contains('uc-reveal'))return;
      node.classList.add('uc-reveal');
      node.style.setProperty('--uc-delay',Math.min(index%4,3)*70+'ms');
      if(observer)observer.observe(node);else node.classList.add('is-visible');
    });
  };
  const initHeader=()=>{
    const header=document.querySelector('.uc-header');
    if(!header||header.dataset.motionReady)return;
    header.dataset.motionReady='true';
    const update=()=>header.classList.toggle('has-scrolled',window.scrollY>24);
    update();
    window.addEventListener('scroll',update,{passive:true});
  };
  const init=()=>{initMotion();initHeader()};
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
  document.addEventListener('shopify:section:load',event=>initMotion(event.target));
})();


;(()=>{
  const selector=[
    '.uc-section__intro',
    '.uc-moment-card',
    '.uc-story__heading',
    '.uc-story__media',
    '.uc-featured-product__copy',
    '.uc-featured-product__media',
    '.uc-steps__grid article',
    '.uc-stats__grid>div',
    '.uc-quotes blockquote',
    '.uc-faq__layout>div',
    '.uc-final>div',
    '.uc-product-main__layout>*',
    '.uc-product-details article'
  ].join(',');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const observer=('IntersectionObserver' in window)&&!reduced.matches?new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  },{threshold:.13,rootMargin:'0px 0px -7% 0px'}):null;
  const initMotion=(root=document)=>{
    document.documentElement.classList.add('uc-motion-ready');
    const nodes=[...root.querySelectorAll(selector)];
    if(root.nodeType===1&&root.matches(selector))nodes.unshift(root);
    nodes.forEach((node,index)=>{
      if(node.classList.contains('uc-reveal'))return;
      node.classList.add('uc-reveal');
      node.style.setProperty('--uc-delay',Math.min(index%4,3)*70+'ms');
      if(observer)observer.observe(node);else node.classList.add('is-visible');
    });
  };
  const initHeader=()=>{
    const header=document.querySelector('.uc-header');
    if(!header||header.dataset.motionReady)return;
    header.dataset.motionReady='true';
    const update=()=>header.classList.toggle('has-scrolled',window.scrollY>24);
    update();
    window.addEventListener('scroll',update,{passive:true});
  };
  const init=()=>{initMotion();initHeader()};
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
  document.addEventListener('shopify:section:load',event=>initMotion(event.target));
})();
